import { Directive, ElementRef, OnInit } from '@angular/core';
import { style } from '../utils/style.utils';

@Directive({
  selector: 'input[sag-ui-range]',
})
export class RangeDirective implements OnInit {
  constructor(private elementRef: ElementRef) {}

  public nativeElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    style(this.elementRef, 'hidden');
  }
}
